<template>
    <div id="allPurchaseOrderList">
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">{{ title }}</div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content purchase-order-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div v-if="!isHideTab" id="divTabMenu" class="btn-group rental-btn-grup-left" role="group"
                                aria-label="Basic example">
                                <!-- <button type="button" id="getvendorPurchaseOrder"
                                    v-on:click="getVendorPurchaseOrder(this)"
                                    :class="'btn btn-secondary ' + vendorPurchase"> Vendor
                                    <span>{{ purchaseOrderCount }}</span></button> -->
                                <button type="button" id="getcustomerPurchaseOrder"
                                    v-on:click="getCustomerPurchaseOrder(this)"
                                    :class="'btn btn-secondary ' + customerPurchase"> Customer
                                    <span>{{ customerpurchaseOrderCount }}</span> </button>
                            </div>

                            <div v-if="isHideTab" id="divTabMenu" class="btn-group rental-btn-grup-left" role="group"
                                aria-label="Basic example">
                                <button type="button" id="getSubmittedPurchaseOrder"
                                    v-on:click="getSubmittedPurchaseOrder(this)"
                                    :class="'btn btn-secondary ' + submitted"> Submitted </button>
                                <button type="button" id="getCanceledPurchaseOrder"
                                    v-on:click="getCanceledPurchaseOrder(this)"
                                    :class="'btn btn-secondary ' + canceled">
                                    Canceled </button>
                                <button type="button" id="getDraftPurchaseOrder"
                                    v-on:click="getDraftPurchaseOrder(this)" :class="'btn btn-secondary ' + draft">
                                    Draft </button>
                                <button type="button" id="getallPurchaseOrder" v-on:click="getAllPurchaseOrder(this)"
                                    :class="'btn btn-secondary ' + all"> All </button>
                            </div>
                            <!-- <div class="mobile-action-btn">
                                <select class="selectpicker">
                                    <optgroup>
                                        <option><button type="button" id="getvendorPurchaseOrder" v-on:click="getVendorPurchaseOrder(this)" :class="'btn btn-secondary '+vendorPurchase"> Vendor <span>  {{purchaseOrderCount}}</span> </button></option>
                                        <option><button type="button" id="getcustomerPurchaseOrder" v-on:click="getCustomerPurchaseOrder(this)" :class="'btn btn-secondary '+customerPurchase"> Customer <span> {{customerpurchaseOrderCount}}</span> </button></option>
                                    </optgroup>
                                </select>
                            </div> -->
                        </div>
                        <customer-purchase-order-list id="customerpurchaseorder"
                            :customerPurchaseVal="customerpurchaseOrder"
                            :vendorPurchaseStatus="selectedStatus"></customer-purchase-order-list>
                        <!-- <vendor-purchase-order id="vendorpurchaseorder" :moduleN="vPurchaseOrder" :vendorPurchaseVal="purchaseOrder" :vendorPurchaseStatus="selectedStatus" v-if="vendorPurchaseOrder == true"></vendor-purchase-order> -->
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { commonMixins } from '../mixins/commonMixins';



import CustomerPurchaseOrderList from '@/components/CustomerPurchaseOrderList';
Vue.component("customer-purchase-order-list", CustomerPurchaseOrderList);
import VendorPurchaseOrderList from '@/components/VendorPurchaseOrderList';
Vue.component("vendor-purchase-order", VendorPurchaseOrderList);
var contex

export default {
    name: "allPurchaseOrderList",
    mixins: [commonMixins],
    data: () => ({
        vPurchaseOrder: "vPurchaseOrder",
        status: [],
        loading: false,
        cantAccessPage: true,
        permissions: [],
        vendorPurchaseOrder: true,
        customerPurchaseOrder: false,
        purchaseOrder: 'purchaseordertab',
        customerpurchaseOrder: 'custPo',
        vendorPurchase: '',
        customerPurchase: '',
        purchaseOrderCount: 0,
        customerpurchaseOrderCount: 0,
        title: '',
        type: '',
        isHideTab: true,
        selectedStatus: 'all',
        submitted: 'active',
        canceled: '',
        all: '',
        draft: '',
    }),

    watch: {
        // permissions: function(permission){
        //     var self = this;
        //     permission.forEach(function (permissions) {
        //         if(permissions.name == 'list_purchase_order' || permissions.name == 'list_customer_purchase_order') {
        //             self.cantAccessPage = true;
        //         }

        //     });
        //     if(self.cantAccessPage == ''){
        //         self.cantAccessPage = false;
        //     }
        // },
        '$route.query': function (val, oldval) {
            var self = this;
            console.log(val);
            console.log(oldval);

            self.type = '';
            self.selectedStatus = 'submitted';
            $('#divTabMenu button').removeClass("active");
            $("#getSubmittedPurchaseOrder").addClass("active");
            $("#maintenanceTabLink a").click();
            $("#maintenanceTabLink").addClass('active');
            if (self.$route.query.by != 'rent') {
            }
            $("#customerpurchaseorderdetailLink").removeClass('active');
            $("#purchaseorderdetailLink").addClass('active');


            $("#divTabMenu button").removeClass("active");

            self.customerPurchase = 'active';
            self.customerPurchaseOrder = true;
            self.vendorPurchaseOrder = false;
            self.title = "Order History";
            self.isHideTab = true;
            self.selectedStatus = 'submitted';
            self.getCustomerPurchaseOrder();

        },
    },

    beforeMount: function () {
        contex = this;
    },

    mounted: function () {

        var self = this;
        // EventBus.$emit("profile", false);

        //self.getPermissions();
        if (self.$route.query.from && self.$route.query.from == 'cust_po_wo' && self.$route.query.type && self.$route.query.type == 'contract') {
            self.type = 'contract';
            self.customerPurchaseOrder = true;
            self.vendorPurchaseOrder = false;
        }

        $("#divTabMenu button").removeClass("active");


        self.customerPurchase = 'active';
        self.customerPurchaseOrder = true;
        self.vendorPurchaseOrder = false;
        self.title = "Order History";


        var prevSelectedTab = localStorage.getItem("cus_purchase_list_prev_tab");

        if (prevSelectedTab == null) {
            self.selectedStatus = "submitted";
            self.submitted = 'active';
            localStorage.setItem('cus_purchase_list_prev_tab', 'submitted_tab');
            $("#getSubmittedPurchaseOrder").addClass("active");

        } else {
            if (prevSelectedTab == 'canceled_tab') {
                self.selectedStatus = "canceled";
                self.canceled = 'active';
                $("#getCanceledPurchaseOrder").addClass("active");
            }
            else if (prevSelectedTab == "draft_tab") {
                self.selectedStatus = "draft";
                self.draft = 'active';
                $("#getDraftPurchaseOrder").addClass("active");
            }
            else if (prevSelectedTab == 'all_tab') {
                self.selectedStatus = "all";
                self.all = 'active';
                $("#getaddPurchaseOrder").addClass("active");
            } else {
                self.selectedStatus = "submitted";
                self.submitted = 'active';
                $("#getSubmittedPurchaseOrder").addClass("active");
            }
        }

        setTimeout(function () {

            if (self.$route.query.from == 'cust_po_wo') {
                self.getCustomerPurchaseOrder();

                if (prevSelectedTab == null || prevSelectedTab == 'submitted_tab') {
                    self.selectedStatus = "submitted";
                    self.submitted = 'active';
                    localStorage.setItem('cus_purchase_list_prev_tab', 'submitted_tab');
                    $("#getSubmittedPurchaseOrder").addClass("active");

                    self.getSubmittedPurchaseOrder();
                }
                else if (prevSelectedTab == 'all_tab') {
                    self.selectedStatus = "all";
                    self.all = 'active';
                    localStorage.setItem('cus_purchase_list_prev_tab', 'all_tab');
                    $("#getallPurchaseOrder").addClass("active");

                    self.getAllPurchaseOrder();
                }
                else if (prevSelectedTab == 'draft_tab') {
                    self.selectedStatus = "draft";
                    self.draft = 'active';
                    localStorage.setItem('cus_purchase_list_prev_tab', 'draft_tab');
                    $("#getDraftPurchaseOrder").addClass("active");
                    self.getDraftPurchaseOrder();
                }
                else {
                    self.selectedStatus = "canceled";
                    self.canceled = 'active';
                    $("#getCanceledPurchaseOrder").addClass("active");
                    self.getCanceledPurchaseOrder();
                }
            }
        }, 500);


        if (self.$route.query.from != 'cust_po_wo') {
            // self.getListCounts();
        }


    },
    metaInfo() {
        var titleStr = "Order History | " + process.env.COPYRIGHT_NAME;
        return {
            title: titleStr
        }
    },
    methods: {
        getVendorPurchaseOrder: function () {

            var self = this;
            $('#divTabMenu button').removeClass("active");
            $("#getvendorPurchaseOrder").addClass("active");
            self.customerPurchaseOrder = false;
            self.vendorPurchaseOrder = true;
            self.title = "Vendor Purchase Order List";
        },
        getCustomerPurchaseOrder: function () {

            var self = this;
            $('#divTabMenu button').removeClass("active");
            $("#getcustomerPurchaseOrder").addClass("active");
            $("#getSubmittedPurchaseOrder").addClass("active");

            self.customerPurchaseOrder = true;
            self.vendorPurchaseOrder = false;

            self.title = "Order History";
        },

        getSubmittedPurchaseOrder: function () {

            var self = this;
            $('#divTabMenu button').removeClass("active");
            $("#getSubmittedPurchaseOrder").addClass("active");
            self.submitted = 'active';
            localStorage.setItem('cus_purchase_list_prev_tab', 'submitted_tab');
            self.canceled = '';
            self.all = '';
            self.draft = '';
            self.selectedStatus = "";

            self.customerPurchaseOrder = false;
            self.$nextTick(() => {
                // Add the component back in
                self.selectedStatus = "submitted";
                self.customerPurchaseOrder = true;
            });

        },
        getCanceledPurchaseOrder: function () {

            var self = this;
            $('#divTabMenu button').removeClass("active");
            $("#getCanceledPurchaseOrder").addClass("active");
            self.selectedStatus = "";
            self.canceled = 'active';
            localStorage.setItem('cus_purchase_list_prev_tab', 'canceled_tab');
            self.submitted = '';
            self.all = '';
            self.customerPurchaseOrder = false;
            self.$nextTick(() => {
                // Add the component back in
                self.selectedStatus = "canceled";
                self.customerPurchaseOrder = true;
                console.log(self.selectedStatus);
            });
        },
        getDraftPurchaseOrder: function () {

            var self = this;
            $('#divTabMenu button').removeClass("active");
            $("#getDraftPurchaseOrder").addClass("active");
            self.selectedStatus = "";
            self.draft = 'active';
            localStorage.setItem('cus_purchase_list_prev_tab', 'draft_tab');
            self.submitted = '';
            self.all = '';
            self.canceled = '';
            self.customerPurchaseOrder = false;
            self.$nextTick(() => {
                // Add the component back in
                self.selectedStatus = "draft";
                self.customerPurchaseOrder = true;
                console.log(self.selectedStatus);
            });
        },
        getAllPurchaseOrder: function () {
            var self = this;
            $('#divTabMenu button').removeClass("active");
            $("#getallPurchaseOrder").addClass("active");
            self.selectedStatus = "";
            self.all = 'active';
            localStorage.setItem('cus_purchase_list_prev_tab', 'all_tab');
            self.submitted = '';
            self.canceled = '';
            self.draft = '';
            if (self.type == '' && (self.$route.query.from != 'cust_po_wo' && self.$route.query.from != 'customer')) {
                self.vendorPurchaseOrder = false;
                self.$nextTick(() => {
                    // Add the component back in
                    self.selectedStatus = "all";
                    self.vendorPurchaseOrder = true;
                    console.log(self.selectedStatus);
                });

            } else {

                self.customerPurchaseOrder = false;
                self.$nextTick(() => {
                    // Add the component back in
                    self.selectedStatus = "all";
                    self.customerPurchaseOrder = true;
                    console.log(self.selectedStatus);
                });

            }
        },

        getListCounts: function () {
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/po_list_count",
                type: "GET",
                headers: this.ajxHeaders,
                data: {
                    type: self.type
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.purchaseOrderCount = data.content.pocount;
                        self.customerpurchaseOrderCount = data.content.custpocount;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        self.error = jqXHR.responseJSON.message;
                    }
                }
            });

        }
    }
};

// EventBus.$on('purchaseOrderCount', function (cnt) {
//     contex.purchaseOrderCount = cnt;
// });
// EventBus.$on('customerpurchaseOrderCount', function (cnt) {
//     contex.customerpurchaseOrderCount = cnt;
// });

</script>



// WEBPACK FOOTER //
// src/components/PurchaseOrderAllList.vue